import React from 'react';

interface LoadingSpinnerProps {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  fullPage?: boolean;
}

const sizeMap = {
  sm: { width: 48, height: 48 },
  md: { width: 80, height: 80 },
  lg: { width: 120, height: 120 },
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  label,
  size = 'md',
  fullPage = false,
}) => {
  const { width, height } = sizeMap[size];

  const spinner = (
    <div className="flex flex-col items-center justify-center gap-3">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        width={width}
        height={height}
      >
        <defs>
          <style>{`
            .vigor-spin-forward {
              transform-origin: 50px 50px;
              animation: vigor-rotate-forward 1.5s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
            }
            .vigor-spin-reverse {
              transform-origin: 50px 50px;
              animation: vigor-rotate-reverse 2s linear infinite;
            }
            .vigor-pulse-energy {
              transform-origin: 50px 50px;
              animation: vigor-pulse 1.5s ease-in-out infinite alternate;
            }
            @keyframes vigor-rotate-forward {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            @keyframes vigor-rotate-reverse {
              0% { transform: rotate(360deg); }
              100% { transform: rotate(0deg); }
            }
            @keyframes vigor-pulse {
              0% { transform: scale(0.85); opacity: 0.8; }
              100% { transform: scale(1.05); opacity: 1; }
            }
          `}</style>
        </defs>
        <circle
          className="vigor-spin-forward"
          cx="50"
          cy="50"
          r="40"
          fill="none"
          stroke="#3A5A40"
          strokeWidth="5"
          strokeDasharray="160 80"
          strokeLinecap="round"
        />
        <circle
          className="vigor-spin-reverse"
          cx="50"
          cy="50"
          r="28"
          fill="none"
          stroke="#E09F3E"
          strokeWidth="4"
          strokeDasharray="60 100"
          strokeLinecap="round"
        />
        <path
          className="vigor-pulse-energy"
          d="M51 32 L39 53 L49 53 L47 68 L61 46 L51 46 Z"
          fill="#3A5A40"
        />
      </svg>
      {label && (
        <p className="text-sm text-gray-500 dark:text-gray-400 font-medium animate-pulse">
          {label}
        </p>
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        {spinner}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center w-full py-16">
      {spinner}
    </div>
  );
};

export default LoadingSpinner;
